Branding features that are included with a product when posting or updating a job ad.
